import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
import React, { memo } from "react";
import Modal from "../common/Modal";
import classNames from "classnames";
import Button from "../common/Button";
import { useTranslation } from "react-i18next";
import TextInput from "../FormComponents/TextInput";
import { capitalize } from "lodash";
function EditDetailsModal(_ref) {
  var _Object$keys;
  var isVisible = _ref.isVisible,
    title = _ref.title,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    onClose = _ref.onClose,
    patient = _ref.patient,
    onEditData = _ref.onEditData,
    onChangeRowData = _ref.onChangeRowData,
    error = _ref.error;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Modal, {
    show: isVisible,
    onClose: onClose,
    title: title,
    className: classNames("w-full sm:w-4/12 flex flex-col lg:w-3/12 h-2/3", _defineProperty({}, className, !!className))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex flex-col overflow-hidden"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: onEditData,
    className: "flex-1 px-4 mt-4 space-y-3 py-3 overflow-y-auto scrollbar-light dark:scrollbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col sm:h-full gap-6 mt-2"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: t("patient_id_label"),
    defaultValue: patient === null || patient === void 0 ? void 0 : patient.patientId,
    onChange: function onChange(val) {
      return onChangeRowData(val, "patientId");
    },
    error: error["patientId"],
    isEditableModal: true,
    required: true,
    placeholder: t("patient_id_placeholder"),
    name: "patientId",
    id: "patientId",
    wrapperClassName: "my-0",
    labelClassName: "!bg-gray-800"
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: t("full_name_label"),
    defaultValue: patient === null || patient === void 0 ? void 0 : patient.patientName,
    onChange: function onChange(val) {
      return onChangeRowData(val, "patientName");
    },
    error: error["patientName"],
    required: true,
    isEditableModal: true,
    placeholder: t("full_name_placeholder"),
    name: "name",
    id: "name",
    wrapperClassName: "my-0",
    labelClassName: "!bg-gray-800"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex my-0"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: t("age_label"),
    defaultValue: parseInt(patient === null || patient === void 0 ? void 0 : patient.patientAge),
    onChange: function onChange(val) {
      return onChangeRowData(val ? "".concat(val, "Y") : "", "patientAge");
    },
    error: error["patientAge"],
    isEditableModal: true,
    required: true,
    placeholder: t("age_label"),
    name: "age",
    id: "age",
    wrapperClassName: "flex items-center mr-3 basis-1/3",
    unit: "Yrs",
    inputMode: "numeric",
    labelClassName: "!bg-gray-800"
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: t("gender_label"),
    defaultValue: patient === null || patient === void 0 ? void 0 : patient.patientGender,
    onChange: function onChange(val) {
      return onChangeRowData(val, "patientGender");
    },
    error: error["patientGender"],
    isEditableModal: true,
    required: true,
    placeholder: t("Sex"),
    name: "gender",
    id: "gender",
    wrapperClassName: "flex items-center mr-3 basis-2/3",
    labelClassName: "!bg-gray-800"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "my-4 tetx-left w-full flex flex-col items-start px-4"
  }, (_Object$keys = Object.keys(error)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (key) {
    if (error[key]) {
      return /*#__PURE__*/React.createElement("p", {
        key: key,
        className: "pt-2 font-medium text-md whitespace-nowrap"
      }, key, ": ", /*#__PURE__*/React.createElement("span", {
        className: "text-red-600"
      }, capitalize(error[key])));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end p-4  border-t border-gray-600"
  }, /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    className: "px-8 py-4",
    onClick: onEditData
  }, t("button.save")))));
}
export default /*#__PURE__*/memo(EditDetailsModal);